export const constantRoutes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录",
      isCheckToken: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "login" */ "../views/personalCenter/personalCenterLogin.vue"
      ),
  },
  {
    path: "/home",
    name: "home",
    meta: {
      title: "首页",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/Home/Home.vue"),
  },
  {
    path: "/feature",
    name: "feature",
    meta: {
      title: "专题列表",
      isCheckToken: true,
      alive: true,
      isFooter: true,
      isScrollTop: true,
    },
    component: () =>
      import(/* webpackChunkName: "feature" */ "../views/Feature/Feature.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    meta: {
      title: "细览页面",
      isCheckToken: true,
      alive: true,
      isFooter: true,
      isScrollTop: true,
    },
    component: () =>
      import(/* webpackChunkName: "detail" */ "../views/Detail/Detail.vue"),
  },
  {
    path: "/imageDetail",
    name: "imageDetail",
    meta: {
      title: "图片细览页",
      isCheckToken: true,
      alive: true,
      isFooter: true,
      isScrollTop: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "imageDetail" */ "../views/Detail/imageDetail.vue"
      ),
  },
  {
    path: "/imageProcess",
    name: "imageProcess",
    meta: {
      title: "图片处理",
      isCheckToken: true,
      alive: false,
      isFooter: false,
      isScrollTop: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "imageProcess" */ "../views/search/imageProcess/index.vue"
      ),
  },
  {
    path: "/source",
    name: "source",
    meta: {
      title: "报史资料",
      isCheckToken: true,
      alive: false,
      isFooter: false,
      isScrollTop: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "homeSource" */ "../views/Home/HomeSource.vue"
      ),
  },
  {
    path: "/explore/FullDbSearch",
    name: "FullDbSearch",
    meta: {
      title: "文章检索",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/eastview/FullDbSearch.vue")
  },
  {
    path: "/explore/ProductExplore",
    name: "ProductExplore",
    meta: {
      title: "产品检索",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    // 产品检索：壳组件 ProductExplore.vue → 业务组件 DbExplore.vue（提供 config、fetchList、权限收敛）
    component: () => import("../views/eastview/ProductExplore.vue"),
    props: { mode: "product" }
  },
  {
    path: "/newspaper",
    name: "newspaper",
    meta: {
      title: "报纸",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    // 报纸检索：业务组件 NewspaperSearch.vue（报纸侧差异全在这里，config / fetchList / 权限收敛）
    component: () => import("../views/eastview/NewspaperSearch.vue"),
    props: { mode: "newspaper" }
  },
  {
    path: "/newspaper/detail/:id?",
    name: "newspaperDetail",
    meta: {
      title: "报纸详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/eastview/NewspaperDetailPage.vue")
  },
  {
    path: "/newspaper/pageDetail",
    name: "newspaperPageDetail",
    meta: {
      title: "版面细览",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/Detail/EastViewNewsPaperDetail.vue")
  },
  {
    path: "/journal",
    name: "journal",
    meta: {
      title: "期刊",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    // 期刊检索：业务组件 JournalSearch.vue（期刊侧差异全在这里，config / fetchList / 权限收敛）
    component: () => import("../views/eastview/mag/JournalSearch.vue"),
    props: { mode: "journal" }
  },
  {
    path: "/book",
    name: "book",
    meta: {
      title: "图书",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/eastview/book/BookNewSearch.vue"),
    props: { mode: "book" }
  },
  {
    path: "/book/search",
    name: "bookSearch",
    meta: {
      title: "图书章节检索",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/eastview/book/BookFullSearch.vue"),
    props: { mode: "book" }
  },
  {
    path: "/book/detail/:id",
    name: "bookDetail",
    meta: {
      title: "图书详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/Detail/book/BookDetail.vue"),
    props: { mode: "book" }
  },
  {
    path: "/book/content/:id",
    name: "bookContent",
    meta: {
      title: "图书内容",
      isCheckToken: true,
      isFooter: false,
      alive: true,
      isScrollTop: false,
    },
    component: () => import("../views/eastview/book/BookContent.vue"),
    props: { mode: "book" }
  },
  {
    path: "/book/proofread/:id",
    name: "bookProofread",
    meta: {
      title: "数据审校",
      isCheckToken: true,
      isFooter: false,
      alive: true,
      isScrollTop: false,
    },
    component: () => import("../views/eastview/book/BookProofread.vue"),
    props: { mode: "book" }
  },
  {
    path: "/product/collection/:id",
    name: "productCollection",
    meta: {
      title: "产品集详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
      // 产品集是「产品检索」的钻取页（DbExplore 只列顶层产品），高亮归属产品检索
      activeMenu: "/explore/ProductExplore",
    },
    component: () => import("../views/eastview/ProductCollection.vue")
  },
  {
    path: "/journal/productDetail",
    name: "journalProductDetail",
    meta: {
      title: "期刊详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/eastview/mag/productMagDetail.vue")
  },
  {
    path: "/journal/journalDetail",
    name: "journalDetail",
    meta: {
      title: "期刊详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/journal/journalDetail.vue")
  },
  {
    path: "/explore/BookCollectionExplore",
    name: "BookCollectionExplore",
    meta: {
      title: "图书集",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true
    },
    component: () => import("../views/eastview/bookCollection/index.vue")
  },
  {
    path: "/book/collection/edit/:id",
    name: "bookCollectionEdit",
    meta: {
      title: "图书集详情",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
      // 图书集详情：前缀是 /book，不加此声明会被高亮成「图书」，实际归属「图书集」
      activeMenu: "/explore/BookCollectionExplore"
    },
    component: () => import("../views/eastview/bookCollection/BookCollectionDetail.vue")
  },
  {
    path: "/accountCenter",
    name: "accountCenter",
    meta: {
      title: "个人中心",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/AccountCenter/AccountCenter.vue")
  },
  {
    path: "/subject",
    name: "subject",
    meta: {
      title: "专题",
      isCheckToken: true,
      isFooter: true,
      alive: true,
      isScrollTop: true,
    },
    component: () => import("../views/subject/index.vue")
  }
];

export default constantRoutes;
